import {useCallback} from 'react'
import * as React from 'react'
import {useLocation, useNavigate} from 'react-router-dom'

import {getHrefWithQueryParams} from '../../../../../../routes'
import Pager from '../../../../../common/Pager/Pager'
import {usePage} from '../../../../../common/Pager/Pager.hooks'
import {hasItemsOnPage} from '../../../../../common/Pager/Pager.utils'
import TestScopePagerWarning from '../../../../../common/Pager/TestScopePager/TestScopePagerWarning'
import type {TestScopesView$data} from '../__generated__/TestScopesView.graphql'
import {COUNT_VISIBLE_SCOPES} from '../TestScopesView.utils'

interface Props {
  testScopesData: TestScopesView$data
  isLoading: boolean
}

function TestScopesViewPager(props: Props) {
  const {testScopesData, isLoading} = props
  const location = useLocation()
  const currentPage = usePage()
  const navigate = useNavigate()
  const changeCurrentPage = useCallback(
    (nextPage: number) => {
      navigate(
        getHrefWithQueryParams(location, null, params => ({
          ...params,
          page: String(nextPage),
        })),
      )
    },
    [location, navigate],
  )

  const total = testScopesData?.testScope?.length ?? 0
  const hasMore = testScopesData.nextHref != null
  const loadedLessThanRequested =
    testScopesData.testScope != null && testScopesData.testScope?.length < COUNT_VISIBLE_SCOPES

  const openTotal = hasMore && !loadedLessThanRequested

  const show =
    hasItemsOnPage(currentPage, {
      pageSize: COUNT_VISIBLE_SCOPES,
      total,
    }) ||
    !loadedLessThanRequested ||
    currentPage !== 1 ||
    !hasMore

  return (
    <>
      <TestScopePagerWarning
        show={show}
        isLoading={isLoading}
        currentPage={currentPage}
        total={total}
      />
      <Pager
        openTotal={openTotal}
        currentPage={currentPage}
        pageSize={COUNT_VISIBLE_SCOPES}
        total={total}
        show={show}
        changeCurrentPage={changeCurrentPage}
      />
    </>
  )
}

export default React.memo(TestScopesViewPager)
